const key = Symbol("modal");

export { key };
